import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';

import {
	Layout, Button, Table, Popconfirm, PageHeader,
} from 'antd';

import './styles.css';

import Create from './Create/mobx';

const { Header, Content } = Layout;

@inject((stores, props) => ({
	store: stores.store[props.store],
	data: stores.store[props.store].items,
	isLoading: stores.store[props.store].isLoading,
	isCreating: stores.store[props.store].isCreating,
}))

@observer
class CrudPage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			createVisible: false,
			editEntity: null,
			filterVisible: false,
			filteredValue: this.props.columns.reduce((prev, curr) => {
				if (curr.defaultFilteredValue) {
					prev[curr.key] = curr.defaultFilteredValue;
				}
				return prev;
			}, {}),
		};
	}

	componentDidMount() {
		if (!this.props.isFetched) {
			this.props.store.fetch();
		}
	}

	filterData = data => data.filter((row) => {
		let condition = true;

		this.columns.forEach((column) => {
			if ((this.state.filteredValue[column.dataIndex] || (this.state.filteredValue[column.dataIndex] || []).length > 0) && column.filterFunction) {
				condition = condition && this.state.filteredValue[column.dataIndex].reduce((prev, curr) => prev || column.filterFunction(curr, row), false);
			}
		});
		return condition;
	})

	render() {
		this.columns = [
			...this.props.columns.map(column => ({
				...column,
				...(column.defaultFilteredValue ? { filteredValue: this.state.filteredValue[column.key] } : {}),
				filterFunction: column.onFilter,
				onFilter: () => true,
			})),
			{
				title: 'Akcije',
				key: 'actions',
				className: 'bo-column-actions',
				width: this.props.actionsWidth,
				render: (text, record) => (
					<Button.Group>
						{this.props.extraButtons(text, record)}

						<Button
							onClick={() => {
								if (this.props.editButtonAction) {
									return this.props.editButtonAction(record);
								}

								return this.setState({
									editEntity: record,
									createVisible: true,
								});
							}}
							icon="edit"
						/>
						<Popconfirm
							placement="topRight"
							title={this.props.deleteButtonPrompt}
							onConfirm={() => {
								record.destroy();
							}}
							okText="Da"
							cancelText="Ne"
						>
							<Button icon="delete" />
						</Popconfirm>
					</Button.Group>
				),
			},
		];

		const data = this.props.processData(this.filterData(this.props.data));
		const footer = this.props.tableFooter(data);
		const { store: { create } } = this.props;
		const { editEntity } = this.state;
		return (
			<div>
				{
					!this.props.hideDefaultButtons ? (
						<Create
							properties={this.props.properties}
							createTitle={this.props.createTitle}
							editTitle={this.props.editTitle}
							entity={editEntity}
							convert={this.props.convert}
							visible={this.state.createVisible}
							isCreating={this.props.isCreating}
							handleCancel={() => this.setState({ createVisible: false, editEntity: null })}
							handleSave={(data) => {
								if (data.id) {
									return editEntity.update(data)
										.then(() => this.setState({ createVisible: false, editEntity: null }));
								}

								return create(data)
									.then(() => this.setState({ createVisible: false, editEntity: null }));
							}
							}
						/>
					) : null
				}
				<PageHeader
					title={this.props.title}
					subTitle={this.props.subTitle}
					extra={(
						<div style={{ marginTop: -4 }}>
							{
								!this.props.hideDefaultButtons
									? (
										<Button
											type="primary"
											icon="plus"
											onClick={() => this.setState({ createVisible: true })}
										>
											{this.props.addButtonText}
										</Button>
									) : null
							}
							{this.props.headerContents}
						</div>
					)}
				/>
				<Content>
					<Table
						onChange={(pagination, filters, sorter) => {
							console.log(filters);
							this.setState(() => ({
								filteredValue: filters,
							}));
						}}
						size="middle"
						bordered
						loading={this.props.isLoading}
						rowKey="id"
						columns={this.columns}
						dataSource={data}
						pagination={{
							showSizeChanger: true,
						}}
						footer={footer}
						{...this.props.tableProps}
					/>
					{this.props.children}
				</Content>
			</div>
		);
	}
}

CrudPage.defaultProps = {
	addButtonText: 'Dodaj Entitet',
	deleteButtonPrompt: 'Da li ste sigurni da želite da obrišete ovaj entitet?',
	createTitle: 'Dodaj Entitet',
	editTitle: 'Izmeni Entitet',
	convert: {},
	extraButtons: () => {},
	tableFooter: () => null,
	tableProps: {},
	useMap: false,
	children: [],
	hideDefaultButtons: false,
	headerContents: null,
	editButtonAction: null,
	processData: data => data,
};

CrudPage.propTypes = {
	processData: PropTypes.func,
	children: PropTypes.node,
	useMap: PropTypes.bool,
	tableProps: PropTypes.shape({}),

	hideDefaultButtons: PropTypes.bool,
	headerContents: PropTypes.node,

	isLoading: PropTypes.bool.isRequired,

	addButtonText: PropTypes.string,
	deleteButtonPrompt: PropTypes.string,

	editButtonAction: PropTypes.func,

	// Actions
	fetchAction: PropTypes.func.isRequired,
	createAction: PropTypes.func.isRequired,
	deleteAction: PropTypes.func.isRequired,
	updateAction: PropTypes.func.isRequired,

	// State
	convert: PropTypes.shape({}),
	columns: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			dataIndex: PropTypes.string,
			key: PropTypes.string,
			render: PropTypes.func,
		})
	).isRequired,

	createTitle: PropTypes.string,
	editTitle: PropTypes.string,

	properties: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			property: PropTypes.string,
			rules: PropTypes.array,
			component: PropTypes.node,

		})
	).isRequired,
	extraButtons: PropTypes.func,
	tableFooter: PropTypes.func,

};
export default CrudPage;
